export default [
  {
    "id": "mat-enem-0516",
    "numero": 2016,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "O condomínio de um edifício permite que cada \nproprietário de apartamento construa um armá-\nrio em sua vaga de garagem. O projeto da ga-\nragem, na escala 1 : 100, foi disponibilizado aos \ninteressados já com as especificações das di-\nmensões do armário, que deveria ter o formato \nde um paralelepípedo retângulo reto, com di-\nmensões, no projeto, iguais a 3cm, 1cm e 2cm. \n \nO volume real do armário, em centímetros cúbi-\ncos, será: \n \nA) 6. \nB) 600. \nC) 6.000. \nD) 60.000. \nE) 6.000.000.",
    "alternativas": {
      "A": "6.",
      "C": "6.000.",
      "D": "60.000.",
      "E": "6.000.000."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 516,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0517",
    "numero": 2017,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma loja que vende sapatos recebeu diversas \nreclamações de seus clientes relacionadas à \nvenda de sapatos de cor branca ou preta. Os \ndonos da loja anotaram as numerações dos \nsapatos com defeito e fizeram um estudo esta-\ntístico com o intuito de reclamar com o fabrican-\nte. A tabela contém a média, a mediana e a \nmoda desses dados anotados pelos donos. \n \n \n \nPara quantificar os sapatos pela cor, os donos \nrepresentaram a cor branca pelo número 0 e a \ncor preta pelo número 1. Sabe-se que a média \nda distribuição desses zeros e uns é igual a \n0,45. \n \nOs donos da loja decidiram que a numeração \ndos sapatos com maior número de reclamações \ne a cor com maior número de reclamações não \nserão mais vendidas. A loja encaminhou um \noficio ao fornecedor dos sapatos, explicando \nque não serão mais encomendados os sapatos \nde cor: \n \nA) branca e os de número 38. \nB) branca e os de número 37 \nC) branca e os de número 36. \nD) preta e os de número 38. \nE) preta e os de número 37.",
    "alternativas": {
      "A": "branca e os de número 38.",
      "B": "branca e os de número 37",
      "D": "preta e os de número 38.",
      "E": "preta e os de número 37."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 517,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0518",
    "numero": 2018,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Para analisar o desempenho de um método \ndiagnóstico, realizam-se estudos em popula-\nções contendo pacientes sadios e doentes Qua-\ntro situações distintas podem acontecer nesse \ncontexto de teste: \n \n1) Paciente TEM a doença e o resultado do teste é \nPOSITIVO. \n \n2) Paciente TEM a doença e o resultado do teste é \nNEGATIVO. \n \n3) Paciente NÃO TEM a doença e o resultado do \nteste é POSITIVO. \n \n4) Paciente NÃO TEM a doença e o resultado do \nteste é NEGATIVO. \n \nUm Índice de desempenho para avaliação de \num teste diagnóstico é a sensibilidade, definida \ncomo a probabilidade de o resultado do teste \nser POSITIVO se o paciente estiver com a do-\nença. O quadro refere-se a um teste diagnóstico \npara a doença A, aplicado em uma amostra \ncomposta por duzentos indivíduos. \n \n \n \nConforme o quadro do teste proposto, a sensibi-\nlidade dele é de: \n \nA) 47,5%. \nB) 85,0%. \nC) 86,3%. \nD) 94,4%. \nE) 95,0%.",
    "alternativas": {
      "C": "86,3%.",
      "E": "95,0%.",
      "A": "47,5%.",
      "B": "85,0%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 518,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0519",
    "numero": 2019,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma pessoa possui um espaço retangular de \nlados 11,5 m e 14 m no quintal de sua casa e \npretende fazer um pomar doméstico de maçãs. \nAo pesquisar sobre o plantio dessa fruta, des-\ncobriu que as mudas de maçã devem ser plan-\ntadas em covas com uma única muda e com \nespaçamento mínimo de 3 metros entre elas e \nentre elas e as laterais do terreno. Ela sabe que \nconseguirá plantar um número maior de mudas \nem seu pomar se dispuser as covas em filas \nalinhadas paralelamente ao lado de maior ex-\ntensão. \n \nO número máximo de mudas que essa pessoa \npoderá plantar no espaço disponível é: \n \nA) 4. \nB) 8. \nC) 9. \nD) 12. \nE) 20.",
    "alternativas": {
      "A": "4.",
      "B": "8.",
      "C": "9.",
      "D": "12."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 519,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0521",
    "numero": 2021,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um pesquisador está realizando várias séries \nde experimentos com alguns reagentes para \nverificar qual o mais adequado para a produção \nde um determinado produto. Cada série consis-\nte em avaliar um dado reagente em cinco expe-\nrimentos diferentes. O pesquisador está especi-\nalmente interessado naquele reagente que \napresentar a maior quantidade dos resultados \nencontrada para aquele reagente. Após a reali-\nzação de cinco séries de experimentos, o pes-\nquisador encontrou os seguintes resultados: \n \n \n \nLevando-se em consideração os experimentos \nfeitos, o reagente que atende às expectativas do \npesquisador é o: \n \nA) 1. \nB) 2. \nC) 3. \nD) 4. \nE) 5.",
    "alternativas": {
      "E": "5.",
      "A": "1.",
      "B": "2.",
      "D": "4."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 521,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0522",
    "numero": 2022,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Em uma cidade, o valor total da conta de ener-\ngia elétrica é obtido pelo produto entre o con-\nsumo (em kWh) e o valor da tarifa do kWh (com \ntributos), adicionado à Cosip (contribuição para \ncusteio da iluminação pública), conforme a ex-\npressão: \n \nValor do kWh (com tributos) x consumo (em \nkWh) + Cosip \n \nO valor da Cosip é fixo em cada faixa de con-\nsumo. O quadro mostra o valor cobrado para \nalgumas faixas. \n \n \n \nSuponha que, em uma residência, todo mês o \nconsumo seja de 150 kWh, e o valor do kWh \n(com tributos) seja de R$ 0,50. O morador des-\nsa residência pretende diminuir seu consumo \nmensal de energia elétrica com o objetivo de \nreduzir o custo total da conta em pelo menos \n10%. Qual deve ser o consumo máximo, em \nkWh, dessa residência para produzir a redução \npretendida pelo morador? \n \nA) 134,1 \nB) 135,0 \nC) 137,1 \nD) 138,6 \nE) 143,1",
    "alternativas": {
      "E": "143,1",
      "A": "134,1",
      "B": "135,0",
      "C": "137,1"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 522,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0523",
    "numero": 2023,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um cliente de uma videolocadora tem o hábito \nde sempre alugar dois filmes por vez. Quando \nos devolve, sempre pega outros dois filmes e \nassim sucessivamente.  \n \nEle soube que a videolocadora recebeu alguns \nlançamentos, sendo 8 filmes de ação, 5 de co-\nmédia e 3 de drama e, por isso, estabeleceu \numa estratégia para ver todos esses 16 lança-\nmentos. Inicialmente alugará, em cada vez, um \nfilme de ação e um de comédia.  \n \nQuando se esgotarem as possibilidades de co-\nmédia, o cliente alugará um filme de ação e um \nde drama, até que todos os lançamentos sejam \nvisto e sem que nenhum filme seja repetido. \n \nDe quantas formas distintas a estratégia desse \ncliente poderá ser posta em prática? \n \nA) 20 x 8! + (3!)2 \n \nB) 8! x 5! X 3! \n \nC) \n8! x 5! x 3!\n28\n \n \nD) \n8! x 5! x 3!\n22\n \n \nE) \n16!\n28",
    "alternativas": {
      "B": "8! x 5! X 3!",
      "C": "8! x 5! x 3! 28",
      "E": "16! 28",
      "A": "20 x 8! + (3!)2"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 523,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0524",
    "numero": 2024,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "O psicólogo de uma empresa aplica um teste \npara analisar a aptidão de um candidato a de-\nterminado cargo. O teste consiste em uma série \nde perguntas cujas respostas devem ser verda-\ndeiro ou falso e termina quando o psicólogo fizer \na décima pergunta ou quando o candidato der a \nsegunda resposta errada. Com base em testes \nanteriores, o psicólogo sabe que a probabilidade \nde o candidato errar uma resposta é 0,20. \n \nA probabilidade de o teste terminar na quinta \npergunta é: \nA) 0,02048. \nB) 0,08192. \nC) 0,24000. \nD) 0,40960. \nE) 0,49152.",
    "alternativas": {
      "C": "0,24000.",
      "D": "0,40960.",
      "A": "0,02048.",
      "B": "0,08192."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 524,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0526",
    "numero": 2026,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "No Brasil há várias operadoras e planos de tele-\nfonia celular. Uma pessoa recebeu 5 propostas \n(A, B, C, D e E) de planos telefônicos. O valor \nmensal de cada plano está em função do tempo \nmensal das chamadas, conforme o gráfico. \nEssa pessoa pretende gastar exatamente \nR$30,00 por mês no telefone. Dos planos tele-\nfônicos apresentados, qual é o mais vantajoso, \nem tempo de chamada, para o gasto previsto \npara essa pessoa? \n \nA) A \nB) B \nC) C \nD) D \nE) E",
    "alternativas": {
      "A": "A",
      "C": "C",
      "D": "D",
      "E": "E"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 526,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0527",
    "numero": 2027,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma empresa farmacêutica produz medicamen-\ntos em pílulas, cada uma na forma de um cilin-\ndro com uma semiesfera com o mesmo raio do \ncilindro em cada uma de suas extremidades. \nEssas pílulas são moldadas por uma máquina \nprogramada para que os cilindros tenham sem-\npre 10mm de comprimento, adequando o raio \nde acordo com o volume desejado. \n \nUm medicamento é produzido em pílulas com 5 \nmm de raio. Para facilitar a deglutição, deseja-\nse produzir esse medicamento diminuindo o raio \npara 4 mm, e, por consequência, seu volume. \nIsso exige a reprogramação da máquina que \nproduz essas pílulas. Use 3 como valor aproxi-\nmado para 𝜋. \n \nA redução do volume da pílula, em milímetros \ncúbicos, após a reprogramação da máquina, \nserá igual a: \n \nA) 168. \nB) 304. \nC) 306. \nD) 378. \nE) 514.",
    "alternativas": {
      "E": "514.",
      "A": "168.",
      "B": "304.",
      "D": "378."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 527,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0528",
    "numero": 2028,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "O Brasil é um país com uma vantagem econô-\nmica clara no terreno dos recursos naturais, \ndispondo de uma das maiores áreas com voca-\nção agrícola do mundo. Especialistas calculam \nque, dos 853 milhões de hectares do país, as \ncidades, as reservas indígenas e as áreas de \npreservação, incluindo florestas e mananciais, \ncubram por volta de 470 milhões de hectares. \nAproximadamente 280 milhões se destinam à \nagropecuária, 200 milhões para pastagens e 80 \nmilhões para a agricultura, somadas as lavouras \nanuais e as perenes, como o café e a fruticultu-\nra. \n \nDe acordo com os dados apresentados, o per-\ncentual correspondente à área utilizada para \nagricultura em relação à área do território brasi-\nleiro é mais próximo de: \nA) 32,8% \nB) 28,6% \nC) 10,7% \nD) 9,4% \nE) 8,0%",
    "alternativas": {
      "A": "32,8%",
      "B": "28,6%",
      "C": "10,7%",
      "D": "9,4%"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 528,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0529",
    "numero": 2029,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "A Figura 1 representa uma gravura retangular \ncom 8 m de comprimento e 6 m de altura. \n \n \n \nFigura 1 \n \nDeseja-se reproduzi-la numa folha de papel \nretangular com 42 cm de comprimento e 30 cm \nde altura, deixando livres 3 cm em cada mar-\ngem, conforme a Figura 2. \n \n \n \nFigura 2 \n \nA reprodução da gravura deve ocupar o máximo \npossível da região disponível, mantendo-se as \nproporções da Figura 1. \n \nA escala da gravura reproduzida na folha do \npapel é: \n \nA) 1 : 3 \nB) 1 : 4 \nC) 1 : 20 \nD) 1 : 25 \nE) 1 : 32",
    "alternativas": {
      "B": "1 : 4",
      "C": "1 : 20",
      "D": "1 : 25",
      "A": "1 : 3"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 529,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0530",
    "numero": 2030,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma empresa que organiza eventos de formatu-\nra confecciona canudos de diploma a partir de \nfolhas de papel quadradas. Para que todos os \ncanudos fiquem idênticos, cada folha é enrolada \nem torno de um cilindro de madeira de diâmetro \nd em centímetros, sem folga, dando-se cinco \nvoltas completas em torno de tal cilindro. Ao \nfinal, amarra-se um cordão no meio do diploma, \nbem ajustado, para que não ocorra o desenro-\nlamento, como ilustrado na figura. \n \n \nEm seguida, retira-se o cilindro de madeira do \nmeio do papel enrolado, finalizando a confecção \ndo diploma. Considere que a espessura da folha \nde papel original seja desprezível. \n \nQual é a medida, em centímetros, do lado da \nfolha de papel usado na confecção do diploma? \n \nA) 𝜋 d \nB) 2 𝜋 d \nC) 4 𝜋 d \nD) 5 𝜋 d \nE) 10 𝜋 d",
    "alternativas": {
      "E": "10 𝜋 d",
      "B": "2 𝜋 d",
      "C": "4 𝜋 d",
      "D": "5 𝜋 d"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 530,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0531",
    "numero": 2031,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma ponte precisa ser dimensionada de forma \nque possa ter pontos de sustentação. Sabe-se \nque a carga máxima suportada pela ponte será \nde 12 t. O ponto de sustentação central recebe-\nrá 60% da carga da ponte, e o restante da carga \nserá distribuído igualmente entre os outros dois \npontos de sustentação. \n \nNo caso de carga máxima, as cargas recebidas \npelos três pontos de sustentação serão, respec-\ntivamente, \n \nA) 1,8 t; 8,4 t; 1,8 t. \nB) 3,0 t; 6,0 t; 3,0 t. \nC) 2,4 t; 7,2 t; 2,4 t. \nD) 3,6 t; 4,8 t; 3,6 t. \nE) 4,2 t; 3,6 t; 4,2 t.",
    "alternativas": {
      "C": "2,4 t; 7,2 t; 2,4 t.",
      "D": "3,6 t; 4,8 t; 3,6 t.",
      "E": "4,2 t; 3,6 t; 4,2 t.",
      "A": "1,8 t; 8,4 t; 1,8 t."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 531,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0532",
    "numero": 2032,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Os incas desenvolveram uma maneira de regis-\ntrar quantidades e representar números utilizan-\ndo um sistema de numeração decimal posicio-\nnai: um conjunto de cordas com nós denomina-\ndo quipus. O quipus era feito de uma corda ma-\ntriz, ou principal (mais grossa que as demais), \nna qual eram penduradas outras cordas, mais \nfinas, de diferentes tamanhos e cores (cordas \npendentes). De acordo com a sua posição, os \nnós significavam unidades, dezenas, centenas e \nmilhares Na Figura 1, o quipus representa o \nnúmero decimal 2 453. Para representar o “ze-\nro\" em qualquer posição, não se coloca nenhum \nnó. \n \n \nO número da representação do quipus da Figu-\nra 2, em base decimal, é: \n \nA) 364. \nB) 463. \nC) 3.064. \nD) 3.640. \nE) 4.603.",
    "alternativas": {
      "B": "463.",
      "C": "3.064.",
      "E": "4.603.",
      "A": "364."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 532,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0533",
    "numero": 2033,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "A maior piscina do mundo, registrada no livro \nGuiness, está localizada no Chile, em San Al-\nfonso dei Mar, cobrindo um terreno de 8 hecta-\nres de área. Sabe-se que 1 hectare corresponde \na 1 hectômetro quadrado.  \n \nQual é o valor, em metros quadrados, da área \ncoberta pelo terreno da piscina? \n \nA) 8. \nB) 80. \nC) 800. \nD) 8.000. \nE) 80.000.",
    "alternativas": {
      "B": "80.",
      "C": "800.",
      "E": "80.000.",
      "A": "8."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 533,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0534",
    "numero": 2034,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Durante uma epidemia de uma gripe viral, o \nsecretário de saúde de um município comprou \n16 galões de álcool em gel, com 4 litros de ca-\npacidade cada um, para distribuir igualmente \nem recipientes para 10 escolas públicas do mu-\nnicípio. O fornecedor dispõe à venda diversos \ntipos de recipientes, com suas respectivas ca-\npacidades listadas: \n• Recipiente I: 0,125 litro  \n \n• Recipiente II: 0,250 litro \n \n• Recipiente III: 0,320 litro \n \n• Recipiente IV: 0,500 litro \n \n• Recipiente V: 0,800 litro \n \n \nO secretário de saúde comprará recipientes de \num mesmo tipo, de modo a instalar 20 deles em \ncada escola, abastecidos com álcool em gel na \nsua capacidade máxima, de forma a utilizar todo \no gel dos galões de uma só vez. \n \nQue tipo de recipiente o secretário de saúde \ndeve comprar? \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "D": "IV.",
      "A": "I.",
      "B": "II.",
      "C": "III."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 534,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0535",
    "numero": 2035,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Os vidros para veículos produzidos por certo \nfabricante têm transparências entre 70% e 90%, \ndependendo do lote fabricado. Isso significa \nque, quando um feixe luminoso incide no vidro, \numa parte entre 70% e 90% da luz consegue \natravessá-lo. Os veículos equipados com vidros \ndesse fabricante terão instaladas, nos vidros \ndas portas, películas protetoras cuja transpa-\nrência, dependendo do lote fabricado, estará \nentre 50% e 70%. Considere que uma porcen-\ntagem P da intensidade da luz, proveniente de \numa fonte externa, atravessa o vidro e a pelícu-\nla. \n \nDe acordo com as informações, o intervalo das \nporcentagens que representam a variação total \npossível de P é: \n \nA) [35; 63]. \nB) [40; 63]. \nC) [50; 70] \nD) [50; 90]. \nE) [70; 90].",
    "alternativas": {
      "D": "[50; 90].",
      "E": "[70; 90].",
      "A": "[35; 63].",
      "C": "[50; 70]"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 535,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0536",
    "numero": 2036,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um cientista trabalha com as espécies I e II de bactérias em um ambiente de cultura. Inicialmente, exis-\ntem 350 bactérias da espécie I e 1.250 bactérias da espécie II. O gráfico representa as quantidades de \nbactérias de cada espécie, em função do dia, durante uma semana. \n \nBactérias das espécies I e II \n \n \n \nEm que dia dessa semana a quantidade total de bactérias nesse ambiente de cultura foi máxima? \n \nA) Terça-feira. \nB) Quarta-feira. \nC) Quinta-feira. \nD) Sexta-feira. \nE) Domingo.",
    "alternativas": {
      "E": "Domingo.",
      "A": "Terça-feira.",
      "C": "Quinta-feira.",
      "D": "Sexta-feira."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 536,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0537",
    "numero": 2037,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um fazendeiro tem um depósito para armazenar \nleite formado por duas partes cúbicas que se \ncomunicam, como indicado na figura. A aresta \nda parte cúbica de baixo tem medida igual ao \ndobro da medida da aresta da parte cúbica de \ncima. A torneira utilizada para encher o depósito \ntem vazão constante e levou 8 minutos para \nencher metade da parte de baixo. \n \n \n \nQuantos minutos essa torneira levará para en-\ncher completamente o restante do depósito? \n \nA) 8 \nB) 10 \nC) 16 \nD) 18 \nE) 24",
    "alternativas": {
      "E": "24",
      "A": "8",
      "B": "10",
      "D": "18"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 537,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0538",
    "numero": 2038,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Diariamente, uma residência consome 20.160 \nWh. Essa residência possui 100 células solares \nretangulares (dispositivos capazes de converter \na luz solar em energia elétrica) de dimensões 6 \ncm x 8 cm. Cada uma das tais células produz, \nao longo do dia, 24 Wh por centímetro de dia-\ngonal. O proprietário dessa residência quer pro-\nduzir, por dia, exatamente a mesma quantidade \nde energia que sua casa consome. \n \nQual deve ser a ação desse proprietário para \nque ele atinja o seu objetivo? \n \nA) Retirar 16 células. \nB) Retirar 40 células. \nC) Acrescentar 5 células. \nD) Acrescentar 20 células. \nE) Acrescentar 40 células.",
    "alternativas": {
      "B": "Retirar 40 células.",
      "C": "Acrescentar 5 células.",
      "E": "Acrescentar 40 células.",
      "A": "Retirar 16 células."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 538,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0539",
    "numero": 2039,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Uma pessoa compra semanalmente, numa \nmesma loja, sempre a mesma quantidade de \num produto que custa R$ 10,00 a unidade. Co-\nmo já sabe quanto deve gastar, leva sempre R$ \n6,00 a mais do que a quantia necessária para \ncomprar tal quantidade, para o caso de eventu-\nais despesas extras.  \nEntretanto, um dia, ao chegar à loja, foi infor-\nmada de que o preço daquele produto havia \naumentado 20%. Devido a esse reajuste, con-\ncluiu que o dinheiro levado era a quantia exata \npara comprar duas unidades a menos em rela-\nção à quantidade habitualmente comprada. \n \nA quantia que essa pessoa levava semanalmen-\nte para fazer compra era: \n \nA) R$ 166,00. \nB) R$ 156,00. \nC) R$ 84,00. \nD) R$ 46,00. \nE) R$ 24,00.",
    "alternativas": {
      "B": "R$ 156,00.",
      "C": "R$ 84,00.",
      "D": "R$ 46,00.",
      "A": "R$ 166,00."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 539,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0540",
    "numero": 2040,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Um executivo sempre viaja entre as cidade A e \nB, que estão localizadas em fusos horários dis-\ntintos. O tempo de duração da viagem de avião \nentre as duas cidades é de 6 horas. Ele sempre \npega um voo que sai de A às 15h e chega à \ncidade B às 18h (respectivos horários locais). \n \nCerto dia, ao chegar à cidade B, soube que \nprecisava estar de volta à cidade A, no máximo, \naté às 13h do dia seguinte (horário local de A). \n \nPara que o executivo chegue à cidade A no \nhorário correto e admitindo que não haja atra-\nsos, ele deve pegar um voo saindo da cidade B, \nem horário local de B, no máximo à(s): \n \nA) 16h. \nB) 10h. \nC) 7h. \nD) 4h. \nE) 1h.",
    "alternativas": {
      "C": "7h.",
      "D": "4h.",
      "E": "1h.",
      "B": "10h."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.1",
    "numeroOriginal": 540,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0541",
    "numero": 2041,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Em uma escola, cinco atletas disputam a meda-\nlha de ouro em uma competição de salto em \ndistância.  \n \nSegundo o regulamento dessa competição, a \nmedalha de ouro será dada ao atleta mais regu-\nlar em uma série de três saltos. Os resultados e \nas informações dos saltos desses cinco atletas \nestão no quadro. \nA medalha de ouro foi conquistada pelo atleta \nnúmero: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "E": "V.",
      "A": "I.",
      "C": "III.",
      "D": "IV."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 541,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0544",
    "numero": 2044,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Após encerrar o período de vendas de 2012, \numa concessionária fez um levantamento das \nvendas de carros novos no último semestre \ndesse ano. Os dados estão expressos no gráfi-\nco: \n \n \n \nAo fazer a apresentação dos dados aos funcio-\nnários, o gerente estipulou como meta para o \nmês de janeiro de 2013 um volume de vendas \n20% superior à média mensal de vendas do \nsemestre anterior. Para atingir essa meta, a \nquantidade mínima de carros que deveriam ser \nvendidos em janeiro de 2013 seria: \n \nA) 17. \nB) 20. \nC) 21. \nD) 24. \nE) 30.",
    "alternativas": {
      "A": "17.",
      "B": "20.",
      "C": "21.",
      "D": "24."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 544,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0545",
    "numero": 2045,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Uma loja decide premiar seus clientes. Cada \ncliente receberá um dos seis possíveis brindes \ndisponíveis, conforme sua ordem de chegada \nna loja. Os brindes a serem distribuídos são: \numa bola, um chaveiro, uma caneta, um refrige-\nrante, um sorvete e um CD, nessa ordem. O \nprimeiro cliente da loja recebe uma bola, o se-\ngundo recebe um chaveiro, o terceiro recebe \numa caneta, o quarto recebe um refrigerante, o \nquinto recebe um sorvete, o sexto recebe um \nCD, o sétimo recebe uma bola, o oitavo recebe \num chaveiro, e assim sucessivamente, segundo \na ordem dos brindes. \n \nO milésimo cliente receberá de brinde um(a): \n \nA) bola. \nB) caneta. \nC) refrigerante. \nD) sorvete. \nE) CD.",
    "alternativas": {
      "E": "CD.",
      "B": "caneta.",
      "C": "refrigerante.",
      "D": "sorvete."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 545,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0546",
    "numero": 2046,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "O ferro é um mineral fundamental para que as \ncélulas mantenham seu bom funcionamento. \nEle é essencial ao transporte de oxigênio, sínte-\nse de DNA e metabolismo energético. É reco-\nmendado para meninos de 9 a 13 anos ingeri-\nrem, pelo menos, 8 mg de ferro por dia. \n \nPesquisadores elaboraram a tabela com alguns \nalimentos e as suas respectivas quantidades de \nferro: \nA diretora de uma escola sabe que deve esco-\nlher para o almoço de seus alunos o máximo de \ncardápios possíveis entre três cardápios exis-\ntentes, no(s) qual(is) cada porção equivale a \n100 g e cada copo a 50 g. \n \n \n \n \n \nPara ter certeza de que seus alunos estão inge-\nrindo a quantidade mínima de ferro recomenda-\nda, a diretora deve escolher o(s) cardápio(s): \n \nA) 1. \nB) 2. \nC) 3. \nD) 1 ou 2. \nE) 1 ou 3.",
    "alternativas": {
      "E": "1 ou 3.",
      "A": "1.",
      "C": "3.",
      "D": "1 ou 2."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 546,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0547",
    "numero": 2047,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um estudante se cadastrou numa rede social na \ninternet que exibe o índice de popularidade do \nusuário. Esse índice é a razão entre o número \nde admiradores do usuário e o número de pes-\nsoas que visitam seu perfil na rede. \n \nAo acessar seu perfil hoje, o estudante desco-\nbriu \nque \nseu \níndice \nde \npopularidade \né \n0,3121212... \n \nO índice revela que as quantidades relativas de \nadmiradores do estudante e pessoas que visi-\ntam seu perfil são: \n \nA) 103 em cada 330. \nB) 104 em cada 333. \nC) 104 em cada 3.333. \nD) 139 em cada 330. \nE) 1.039 em cada 3.330.",
    "alternativas": {
      "D": "139 em cada 330.",
      "E": "1.039 em cada 3.330.",
      "A": "103 em cada 330.",
      "B": "104 em cada 333."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 547,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0548",
    "numero": 2048,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Uma fábrica de rapadura vende seus produtos \nempacotados em uma caixa com as seguintes \ndimensões: 25 cm de comprimento; 10 cm de \naltura e 15 cm de profundidade. O lote mínimo \nde rapaduras vendido pela fábrica é um agru-\npamento de 125 caixas dispostas conforme a \nfigura. \n \n \nQual é o volume do lote mínimo comercializado \npela fábrica de rapaduras? \n \nA) 3.750 cm3 \nB) 18.750 cm3 \nC) 93.750 cm3 \nD) 468.750 cm3 \nE) 2.343.750 cm3",
    "alternativas": {
      "A": "3.750 cm3",
      "B": "18.750 cm3",
      "C": "93.750 cm3",
      "D": "468.750 cm3"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 548,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0549",
    "numero": 2049,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Uma concessionária de automóveis revende \natualmente três marcas de veículos, A, B e C, \nque são responsáveis por 50%, 30% e 20%, \nrespectivamente, de sua arrecadação. Atual-\nmente, o faturamento médio mensal dessa em-\npresa é de R$ 150.000,00. A direção dessa \nempresa estima que, após uma campanha pu-\nblicitária a ser realizada, ocorrerá uma elevação \nde 20%, 30% e 10% na arrecadação com as \nmarcas A, B e C, respectivamente. \n \nSe os resultados estimados na arrecadação \nforem alcançados, o faturamento médio mensal \nda empresa passará a ser de: \n \nA) R$ 180.000,00. \nB) R$ 181.500,00. \nC) R$ 187.500,00. \nD) R$ 240.000,00. \nE) R$ 257.400,00.",
    "alternativas": {
      "D": "R$ 240.000,00.",
      "A": "R$ 180.000,00.",
      "B": "R$ 181.500,00.",
      "C": "R$ 187.500,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 549,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0550",
    "numero": 2050,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um lojista adquiriu novas embalagens para pre-\nsentes que serão distribuídas aos seus clientes. \nAs embalagens foram entregues para serem \nmontadas e têm forma dada pela figura. \n \n \nApós montadas, as embalagens formarão um \nsólido com quantas arestas? \n \nA) 10 \nB) 12 \nC) 14 \nD) 15 \nE) 16",
    "alternativas": {
      "E": "16",
      "B": "12",
      "C": "14",
      "D": "15"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 550,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0551",
    "numero": 2051,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um homem, determinado a melhorar sua saúde, \nresolveu andar diariamente numa praça circular \nque há em frente à sua casa. Todos os dias ele \ndá exatamente 15 voltas em torno da praça, que \ntem 50 m de raio. \n \nUse 3 como aproximação para 𝜋. \n \nQual é a distância percorrida por esse homem \nem sua caminhada diária? \n \nA) 0,30 km \nB) 0,75 km \nC) 1,50 km \nD) 2,25 km \nE) 4,50 km",
    "alternativas": {
      "E": "4,50 km",
      "A": "0,30 km",
      "C": "1,50 km",
      "D": "2,25 km"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 551,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0552",
    "numero": 2052,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Enquanto as lâmpadas comuns têm 8 mil horas \nde vida útil, as lâmpadas LED têm 50 mil horas. \n \nDe acordo com a informação e desprezando \npossíveis algarismos na parte decimal, a lâm-\npada LED tem uma durabilidade de: \n \nA) 1.750 dias a mais que a lâmpada comum. \nB) 2.000 dias a mais que a lâmpada comum. \nC) 2.083 dias a mais que a lâmpada comum. \nD) 42.000 dias a mais que a lâmpada comum. \nE) 1.008.000 dias a mais que a lâmpada co-\nmum.",
    "alternativas": {
      "E": "1.008.000 dias a mais que a lâmpada co- mum.",
      "A": "1.750 dias a mais que a lâmpada comum.",
      "B": "2.000 dias a mais que a lâmpada comum.",
      "D": "42.000 dias a mais que a lâmpada comum."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 552,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0553",
    "numero": 2053,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um construtor pretende murar um terreno e, \npara isso, precisa calcular o seu perímetro. O \nterreno está representado no plano cartesiano, \nconforme a figura, no qual foi usada a escala \n1:500. Use 2,8 como aproximação para √8. \n \n \n \nDe acordo com essas informações, o perímetro \ndo terreno, em metros, é: \n \nA) 110. \nB) 120. \nC) 124. \nD) 130. \nE) 144.",
    "alternativas": {
      "C": "124.",
      "E": "144.",
      "A": "110.",
      "B": "120."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 553,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0554",
    "numero": 2054,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "A probabilidade de um empregado permanecer \nem uma dada empresa particular por 10 anos \nou mais é de 1/6. \n \nUm homem e uma mulher começam a trabalhar \nnessa companhia no mesmo dia. Suponha que \nnão haja nenhuma relação entre o trabalho dele \ne o dela, de modo que seus tempos de perma-\nnência na firma são independentes entre si. \n \nA probabilidade de ambos, homem e mulher, \npermanecerem nessa empresa por menos de \n10 anos é de: \n \nA) 60/36 \nB) 25/36 \nC) 24/36 \nD) 12/36 \nE) 1/36",
    "alternativas": {
      "A": "60/36",
      "B": "25/36",
      "C": "24/36",
      "D": "12/36"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 554,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0555",
    "numero": 2055,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "O criador de uma espécie de peixe tem sete \ntanques, sendo que cada tanque contém 14600 \nlitros de água. Nesses tanques, existem em \nmédia cinco peixes para cada metro cúbico (m3) \nde água. Sabe-se que cada peixe consome 1 \nlitro de ração por semana. O criador quer cons-\ntruir um silo que armazenará a ração para ali-\nmentar sua criação. \nQual é a capacidade mínima do silo, em litros, \npara armazenar a quantidade de ração que \ngarantirá a alimentação semanal dos peixes? \n \nA) 511 \nB) 5.110 \nC) 51.100 \nD) 511.000 \nE) 5.110.000",
    "alternativas": {
      "D": "511.000",
      "E": "5.110.000",
      "A": "511",
      "C": "51.100"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 555,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0556",
    "numero": 2056,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um agricultor possui em sua fazenda um silo \npara armazenar sua produção de milho. O silo, \nque na época da colheita é utilizado em sua \ncapacidade máxima, tem a forma de um parale-\nlepípedo retângulo reto, com os lados da base \nmedindo L metros e altura igual a h metros. O \nagricultor deseja duplicar a sua produção para o \npróximo ano e, para isso, irá comprar um novo \nsilo, no mesmo formato e com o dobro da capa-\ncidade do atual. O fornecedor de silos enviou \numa lista com os tipos disponíveis e cujas di-\nmensões são apresentadas na tabela: \n \n \n \nPara atender às suas necessidades, o agricultor \ndeverá escolher o silo de tipo: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "E": "V.",
      "A": "I.",
      "C": "III.",
      "D": "IV."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 556,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0557",
    "numero": 2057,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um construtor precisa revestir o piso de uma \nsala retangular. Para essa tarefa, ele dispõe de \ndois tipos de cerâmicas: \n \na) cerâmica em forma de quadrado de lado \n20 cm, que custa R$ 8,00 por unidade; \n \nb) cerâmica em forma de triângulo retângulo \nisósceles de catetos com 20 cm, que custa \nR$ 6,00 por unidade. \n \nA sala tem largura de 5 m e comprimento de \n6m. O construtor deseja gastar a menor quantia \npossível com a compra de cerâmica. Sejam x o \nnúmero de peças de cerâmica de forma qua-\ndrada e y o número de peças de cerâmica de \nforma triangular. \nIsso significa, então, encontrar valores para x e \ny tais que 0,04x + 0,02y ≥ 30 e que tomem o \nmenor possível valor de: \n \nA) 8x + 6y.  \nB) 6x + 8y.  \nC) 0,32x + 0,12y. \nD) 0,32x + 0,02y. \nE) 0,04x + 0,12y.",
    "alternativas": {
      "A": "8x + 6y.",
      "B": "6x + 8y.",
      "D": "0,32x + 0,02y.",
      "E": "0,04x + 0,12y."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 557,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0558",
    "numero": 2058,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "A tabela apresenta uma estimativa da evolução \nda população brasileira por faixa etária, em mi-\nlhões de pessoas, para 2020, 2030 e 2045. \n \n \n \nCom base na tabela, o valor que mais se apro-\nxima da média dos percentuais da população \nbrasileira na faixa etária até 14 anos, nos anos \nde 2020, 2030 e 2045, é: \n \nA) 21,5. \nB) 21,7. \nC) 48,0. \nD) 48,3. \nE) 48,5.",
    "alternativas": {
      "A": "21,5.",
      "B": "21,7.",
      "C": "48,0.",
      "E": "48,5."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 558,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0559",
    "numero": 2059,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Um artista deseja pintar em um quadro uma \nfigura na forma de triângulo equilátero ABC de \nlado 1 metro. Com o objetivo de dar um efeito \ndiferente em sua obra, o artista traça segmentos \nque unem os pontos médios D, E e F dos lados \nBC, AC e AB, respectivamente, colorindo um \ndos quatro triângulos menores, como mostra a \nfigura. \n \n \n \nQual é a medida da área pintada, em metros \nquadrados, do triângulo DEF? \nA) 1/16 \nB) √3/16 \nC) 1/8 \nD) √3/8 \nE) √3/4",
    "alternativas": {
      "C": "1/8",
      "D": "√3/8",
      "A": "1/16",
      "B": "√3/16"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.2",
    "numeroOriginal": 559,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];